export default __webpack_public_path__ + "static/media/componentwave.9a9f0e1b.png";